import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'UIComponents/elements/headings';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalDataErrorMessage() {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    "data-test-id": "approval-data-error-message",
    title: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalDataError.title"
      })
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalDataError.content"
      })
    })
  });
}